import React, { useState, useEffect } from "react";
import { Edit } from "lucide-react";
import "./ProductDetails.css";
import BaseButton from "../Common/BaseButton";
import Button from 'react-bootstrap/Button';
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const ProductDescription = (props) => {
  const { productdescription, handleProductRegenerate, previewMode, loading, handleManualEdit, onHide, sectionId, sectionTitle, isHidden, onUnhide } = props;
  const [isEditing, setIsEditing] = useState(false);
  const [description, setDescription] = useState(productdescription);
  const [previousResponse, setPreviousResponse] = useState(productdescription || "");

  useEffect(() => {
    if (productdescription !== undefined) {
      setDescription(productdescription);
    }
  }, [productdescription]);

  useEffect(() => {
    if (description && description.trim() !== "") {
      setPreviousResponse(description);
    }
  }, [description]);

  const toggleEdit = () => {
    setIsEditing(!isEditing);
  };

  
 const handleDoneClick = () => {
    setIsEditing(false);
    handleManualEdit("description", description);
  };
  
  const handleRegenerate = async (type, formData, description) => {
    let furtherDetailsToSend = "";
    let customPromptToSend = null;

    if (typeof formData === "object" && formData !== null) {
      if (formData.reason && formData.reason.trim() !== "") {
        furtherDetailsToSend = formData.reason;
        customPromptToSend = null;
      } else {
        customPromptToSend = {
          goal: formData.goal,
          role: formData.role,
          constraints: formData.constraints,
        };
      }
    } else if (typeof formData === "string") {
      furtherDetailsToSend = formData;
    }

    await handleProductRegenerate(type, furtherDetailsToSend, description, customPromptToSend, previousResponse);
  };

  return (
    <div className="product-section">
      <div className="section-header">
        <div className="section-title">Product description</div>
        {!previewMode && (
          isEditing ? (
            <Button variant="dark" onClick={handleDoneClick}>Done</Button>
          ) : (
            <div className="button-group">
              <BaseButton
                className="outlineprimary"
                children="Regenerate Text"
                imageSrc="/regenerate-text.svg"
                isModalOpen={true}
                handleClick={(formData) => handleRegenerate("description", formData, description)}
              />
              {isHidden && onUnhide ? (
                <BaseButton
                  className="outlineprimary"
                  children="Unhide Section"
                  handleClick={onUnhide}
                />
              ) : onHide ? (
                <BaseButton
                  className="outlineprimary"
                  children="Hide Section"
                  handleClick={() => onHide(sectionId, sectionTitle)}
                />
              ) : null}
              <BaseButton
                className="outlineprimary btn-sm"
                children="Edit Text"
                imageSrc="/edit-text.svg"
                handleClick={toggleEdit}
              />
            </div>
          )
        )}
      </div>

     
        {loading ? (
          <div>
            <Skeleton height={12} width="90%" style={{ marginBottom: 5 }} count={5} />
          </div>
        ) : isEditing ? (
          <textarea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            className="product-description-input form-control"
          />
        ) : (
          <div className="description-tabs">
          <p className="productDescription">{description}</p>
          </div>
        )}
      
    </div>
  );
};

export default ProductDescription;
